import type LogRocket from 'logrocket';
import { hasPerformanceConsent } from '@aspendental/web-shared-utils';

let initialized = false;

export function resetInitialized() {
	initialized = false;
}

export const initializeLogRocket = (environment: string, projectId: string): void => {
	if (!environment || environment !== 'prod' || !projectId || initialized || !hasPerformanceConsent()) return;

	// Another app on the same domain may have already initialized LogRocket
	if (typeof window !== 'undefined' && window.LogRocket) {
		initialized = true;
		return;
	}

	initialized = true;

	import('logrocket')
		.then(({ default: LR }) => {
			try {
				LR.init(projectId);
				window.LogRocket = LR;
			} catch {
				// LogRocket init can fail in certain browser environments.
				// Reset flag to allow retry on next navigation.
				initialized = false;
			}
		})
		.catch(() => {
			// Dynamic import can fail due to network issues.
			// Reset flag to allow retry on next navigation.
			initialized = false;
		});
};

declare global {
	interface Window {
		LogRocket: typeof LogRocket;
	}
}
